document.querySelector(".cpt-ajax-load-more-btn")?.addEventListener("click", async () => {
  const btn = document.querySelector('.cpt-ajax-load-more-btn');
  const btnSpinner = btn.querySelector('.spinner-border');
  btnSpinner?.classList.remove('d-none');
  btn.disabled = true;

  try {
    await asyncFetchPosts();
  } finally {
    btnSpinner?.classList.add('d-none');
    btn.disabled = false;
  }
});

async function asyncFetchPosts(filterCategory) {
  const archivePostsContainer = document.querySelector('.archive-posts-container');
  const archiveMain = document.querySelector('#main');
  const currentPage = Number(archivePostsContainer.dataset.current_page);
  const nextPage = filterCategory ? 1 : currentPage + 1;
  const initialPosts = Number(archivePostsContainer.dataset.initial_posts);
  const postsPerPage = Number(archivePostsContainer.dataset.posts_per_page);
  const cptKind = archivePostsContainer.dataset.cpt_kind;
  let cptCategory = archivePostsContainer.dataset.cpt_category;

  if (filterCategory) {
    archivePostsContainer.dataset.cpt_category = filterCategory;
    cptCategory = filterCategory;
  }

  if (filterCategory && !archiveMain.querySelector('.loading-state-wrapper')) {
    archivePostsContainer.classList.add('d-none');
    archivePostsContainer.insertAdjacentHTML('afterend', cpt_ajax_load_more.loading_state);
  }

  try {
    const response = await fetch(cpt_ajax_load_more.ajax_url, {
      method: 'POST',
      body: new URLSearchParams({
        action: "cpt_archive_posts_update",
        current_page: nextPage,
        posts_per_page: filterCategory ? initialPosts : postsPerPage,
        initial_posts: initialPosts,
        cpt_kind: cptKind,
        cpt_category: cptCategory,
        security: cpt_ajax_load_more.nonce,
        lang: cpt_ajax_load_more.lang || '',
      }),
    });

    if (!response.ok) {
      throw new Error(`[${response.status}] ${response.statusText}`);
    }

    //converting response string to node elements
    const parser = new DOMParser();
    const responseJson = await response.json();
    const htmlContent = responseJson.html_content;
    const newMaxNumPages = responseJson.max_num_pages;
    const articles = parser.parseFromString(htmlContent, "text/html").body.querySelectorAll('article');

    if (filterCategory) archivePostsContainer.innerHTML = ''; //clearing posts if filter is applied, otherwise appending to existing ones

    //appending nodes
    for (const article of articles) {
      archivePostsContainer.appendChild(article);
    }

    archivePostsContainer.dataset.max_num_pages = newMaxNumPages;

    //if max number of pages is same as current page, removing show more btn
    archivePostsContainer.dataset.current_page = nextPage;

    const btn = document.querySelector('.cpt-ajax-load-more-btn');
    if (archivePostsContainer.dataset.max_num_pages == nextPage) {
      if (btn) btn.classList.add('d-none');
    } else {
      if (btn) btn.classList.remove('d-none');
    }

    // Remove loading state
    const loadingState = archiveMain.querySelector('.loading-state-wrapper');
    if (loadingState) {
      archivePostsContainer.classList.remove('d-none');
      loadingState.remove();
    }

  } catch (error) {
    console.error('Something went wrong ;-/ \n', error);
  }
}

function clearFilters() {
  const cptArchiveFilters = cptArchiveFiltersContainer?.querySelectorAll('button');
  cptArchiveFilters?.forEach((filter) => filter.classList.remove('active'));
}

const cptArchiveFiltersContainer = document.querySelector('.archive-posts-cat-filters');

if (cptArchiveFiltersContainer) {
  const cptArchiveFilters = cptArchiveFiltersContainer.querySelectorAll('button');
  const archivePostsContainer = document.querySelector('.archive-posts-container');

  cptArchiveFilters.forEach((filterCard) => {
    filterCard.addEventListener("click", async (event) => {
      let category = filterCard.getAttribute('data-filter');
      const prevActiveFilter = event.target.classList.contains('active');

      clearFilters();

      if (filterCard.getAttribute('data-filter') == "all" || prevActiveFilter) {
        category = 'all';
      }

      if (!prevActiveFilter) {
        filterCard.classList.add('active');
      }

      if (prevActiveFilter && cptArchiveFilters[0].getAttribute('data-filter') == 'all') {
        cptArchiveFilters[0].classList.add('active');
      }

      // archivePostsContainer.innerHTML = '';

      await asyncFetchPosts(category);

      // Update link
      let currentURL = window.location.href;
      let newURL = currentURL;

      if (event.target.classList.contains('active')) {
        const filter = event.target.getAttribute('data-filter');

        if (filter && filter !== 'all') {
          currentURL = currentURL.split('?')[0].split('page')[0];
          newURL = currentURL.toString() + '?filter=' + filter;
        } else {
          currentURL = currentURL.split('?')[0].split('page')[0];
          newURL = currentURL.toString();
        }
      } else {
        currentURL = currentURL.split('?')[0];
        newURL = currentURL.toString();
      }
      window.history.pushState(null, null, newURL);
    });
  });
}
